<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chapter-title---IVP sigil_not_in_toc" id="_idParaDest-3" xml:lang="en-US"><a id="_idTextAnchor001"></a>Diagram of the human brain</h2>
<div class="photo">
<img alt="brain.jpg" class="img90" src="Images/brain.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dia.vue?7920e6fd